import script from "./LandingMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./LandingMenuItem.vue?vue&type=style&index=0&id=3a528b44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a528b44"]])

export default __exports__